<div
  class="tooltip-wrapper"
  [matTooltip]="tooltip || label"
  [matTooltipDisabled]="!tooltip && label && !minimized"
  [matTooltipShowDelay]="500"
>
  <button
    mat-raised-button
    [color]="color"
    [routerLink]="link"
    [disabled]="disabled"
    (click)="buttonClick.emit(elementRef)"
    [attr.data-cy]="cypressIdWithPrefix"
  >
    @if (icon && !iconOnly) {
      <mat-icon [attr.iconPositionEnd]="iconPosition === 'right' ? true : undefined">{{ icon }}</mat-icon>
    }
    @if (iconOnly) {
      <div class="icon-only-wrapper"
        ><mat-icon>{{ icon }}</mat-icon></div
      >
    }
    {{ label }}
  </button>
</div>
